<template>
  <section>
    <OrderConfirmView>
      <template #payment-list>
        <KeepAlive>
          <PaymentList workflow="trade">
            <template #dex-info>
              <div :class="$style.dexPanel">
                <DexPanel
                  :showCopyButton="false"
                  walletAddress="Exchange wallet"
                  network=""
                />
              </div>
            </template>
            <template #view-fees>
              <ViewFees />
            </template>
          </PaymentList>
        </KeepAlive>
      </template>
    </OrderConfirmView>
  </section>
</template>

<script>
import PaymentList from "@/components/localPaymentProcess/PaymentList.vue";
import ViewFees from "@/components/trade/ViewFees.vue";
import OrderConfirmView from "@/components/OrderConfirmView.vue";
import DexPanel from "@/components/trade/DexPanel.vue";

export default {
  name: "Trade.Payment.List.Process",
  props: {},
  data() {
    return {};
  },
  computed: {},
  components: {
    PaymentList,
    OrderConfirmView,
    ViewFees,
    DexPanel
  },
  methods: {},
  created() {},
  mounted() {}
};
</script>

<style module lang="scss">
@import "~rfs/scss";

.dexPanel {
  padding: rfs-value(14px);
  border-radius: rfs-value(10px);
  background-color: color-mix(in srgb, var(--legend-c-bg) 50%, transparent);
  margin-bottom: rfs-value(14px);
}
</style>
